module.exports = __webpack_public_path__ + "static/media/valueprop-spend.272106ae.png";